import { useHasRole } from '../../../api/access';
import { useCustomerQuery } from '../../../api/customers';
import { OwnerVerificationStep } from '../HomePage/KYB/OwnerVerificationStep';

export function OwnerVerificationWrapper({ children }: { children: React.ReactNode }) {
  const isOwner = useHasRole('OWNER');
  const customerQuery = useCustomerQuery({ enabled: isOwner });

  if (isOwner) {
    if (!customerQuery.isSuccess) return null;
    if (customerQuery.data?.individual?.state !== 'VERIFIED') {
      return <OwnerVerificationStep />;
    }
  }

  return children;
}
